<template>
    <BreadCrumb PageTitle="Paiement ambulant" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/PaiementAmbulant/Paiement.vue";
    export default defineComponent({
      name: "PaiementAmbulantPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>